import { AppContext as e, ErrorLevel as t } from "./types.mjs";
import { detectBrowser as n } from "./detectBrowser.mjs";
import { detectPlatform as r } from "./detectPlatform.mjs";
//#region src/createErrorMeta.ts
function i() {
	return r() === "native" ? { platform: "native" } : {
		platform: "web",
		browser: n()
	};
}
function a(n) {
	return {
		context: {
			app: n.context?.app ?? e.Guest,
			level: n.context?.level ?? t.Error,
			vertical: n.context?.vertical ?? "unknown"
		},
		location: {
			pageUrl: n.location?.pageUrl ?? "",
			route: n.location?.route,
			componentStack: n.location?.componentStack
		},
		platform: n.platform ?? i(),
		user: n.user,
		fingerprint: n.fingerprint,
		extra: n.extra
	};
}
//#endregion
export { a as createErrorMeta };
